import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.792 2.441a.75.75 0 0 1 .059 1.06 8.2 8.2 0 0 0-1.987 4.123.75.75 0 0 1-1.48-.248A9.7 9.7 0 0 1 4.734 2.5a.75.75 0 0 1 1.059-.059m12.415 0a.75.75 0 0 1 1.06.059 9.7 9.7 0 0 1 2.347 4.876.75.75 0 1 1-1.48.248A8.2 8.2 0 0 0 18.15 3.5a.75.75 0 0 1 .06-1.059"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243q.01.14.01.281a3.75 3.75 0 1 1-7.49-.28 24.6 24.6 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.206A8.22 8.22 0 0 0 5.25 9.75zM12 3.75A5.25 5.25 0 0 0 6.75 9v.75a9.7 9.7 0 0 1-1.81 5.66c1.38.438 2.814.752 4.291.927a23.5 23.5 0 0 0 5.538 0 23 23 0 0 0 4.29-.928 9.7 9.7 0 0 1-1.81-5.659v-.707L17.25 9c0-2.9-2.35-5.25-5.25-5.25M9.752 17.9l-.002.1a2.25 2.25 0 1 0 4.498-.1 25 25 0 0 1-4.496 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }